import { BotProviderIndex } from '@/Workspaces/BotProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/botProvider/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <BotProviderIndex />
}
